module.exports = __webpack_public_path__ + "img/logo22.bb32cda1.png";